import { render } from "./FormCreateOrUpdate.vue?vue&type=template&id=cedb1254&scoped=true"
import script from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"

import "./FormCreateOrUpdate.vue?vue&type=style&index=0&id=cedb1254&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cedb1254"

export default script